import { ErrorsModal, Preloader } from '../../../utils';
import { User } from '../../../models';
import CoreLeagueSetupView from '../../../views/CoreLeagueSetup';

/**
 * @desc League Settings View Class
 */
export default class CoreRegenerationRestartView extends CoreLeagueSetupView {
	get template() {
		throw new Error("Need set template for child CoreRegenerationRestartView class");
	}

	get className() {
		return "league-regeneration-page shadow";
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			...super.ui(),
			regenerate_league: '.js-submit-regenerate-league'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			...super.events(),
			'click @ui.regenerate_league': 'regenerationLeague',
			'submit @ui.league_form':      'regenerationLeague'
		};
	}

	/**
	 * Set model events
	 * @returns object
	 */
	modelEvents() {
		return {
			'league:form:errors':    'checkFormErrors',
			'league:create:errors':  'regenerationLeagueError',
			'league:create:success': 'regenerationLeagueSuccess'
		};
	}

	/**
	 * Initialize view data
	 */
	async initialize() {
		this.rounds                   = this.getOption( 'rounds' );
		this.old_league_id            = this.getOption( 'league_id' );
		this.is_commissioner          = true;
		this.check_origin_league_type = false;

		Preloader.show();
		await this.fetchData();

		this.addRounds()
			.updateView();
		Preloader.hide();
	}

	/**
	 * Get all base data for this class
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		return Promise.all( [
			this.rounds.fetch(),
			this.model.setRegenerateShowUrl().fetch(
				{
					data: {
						'id': this.old_league_id
					}
				}
			)
		] );
	}

	addRounds() {
		this.model.setRounds(this.rounds)
			.recalculateFinalsStartRoundFormat(this.model.get('rounds'))
		;

		return this;
	}

	/**
	 * Update base class model
	 * @returns {LeagueCreateView}
	 */
	updateModel() {

		this.model.set( {
			first_name: User.get( 'firstname' ),
			last_name:  User.get( 'lastname' ).charAt( 0 )
		} )
			.updateFormData( this.rounds, true, "", true )
			.checkIsPossibleLeave()
			.setAvatar()
			.checkOriginTypeLeague( this.check_origin_league_type )
			// .setDefaultData();

		return this;
	}

	regenerationLeague( element ) {
		element.preventDefault();

		if ( !this.model.isFormErrors() ) {
			Preloader.show();
			let formData              = this.model.getFormData();
			formData.regenerated_from = this.old_league_id;
			this.model.createLeague( formData );
		}

		return this;
	}

	regenerationLeagueError( errors ) {
		Preloader.hide();
		ErrorsModal.show( errors );
	}

	regenerationLeagueSuccess() {

	}
}